import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { CheckboxView } from "./checkbox-view"


export class CheckBoxComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'CheckBox';
        this.addProperty("Checked","data-b-comp-checked",new BooleanPropertyType(this),false,false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new CheckboxElement(parent);
        return result;
    }
        
}
export class CheckboxElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new CheckboxView();
    }
    public getTypeId(): string {
        return "VM-C4398C2B-D34E-4BFF-A38C-7B643448B63E"
    }

    public set Checked(v: boolean) { this._Checked = v; } public get Checked(): boolean { return this._Checked;} private _Checked: boolean;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitCheckBox(this,parameter);
    }
    
}
